import script from "./Item.vue?vue&type=script&setup=true&lang=js"
export * from "./Item.vue?vue&type=script&setup=true&lang=js"

import "./Item.vue?vue&type=style&index=0&id=709b8158&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709b8158"]])

export default __exports__